import React from "react";



export default function Training() {

  return (
    <>
      <div className="custom_container1_traning">
        <div className="d-flex flex-column flex-lg-row">
          <div className=" d-flex justify-content-center align-items-center">
            <div className="w-100 page2phr_traning">
              <h1 className="pb-4">
                On-Demand Aviation Training for Professionals
              </h1>
             <div className="w-100  d-flex justify-content-center align-items-center"> <p className="w-100 w-lg-75 text-justify px-2 px-lg-5">
                At Andromeda Sim, we offer on-demand training solutions
                specifically tailored for professionals in the aviation
                industry. Whether you work in aviation management, airline
                operations, aviation safety, or customer service, our expert-led
                training equips you with the skills and knowledge needed to
                address the unique challenges of the aviation sector. Learn at
                your own pace with flexible training options designed to provide
                immediate value in your role.
              </p>
              </div>
            </div>
          </div>
        </div>
      </div>
<div className="py-5 traning_card_btn_main_div">
    <div className="traning_key_feature_div">
    <h1>Key Features</h1>
    </div>
      <div className="traning_card_main_div d-flex flex-wrap p-4 gap-5 align-items-start justify-content-center ">
        <div className="col-12 col-md-6 col-lg-3 traning_card">
          <div className="custom-roadmap-box-container rounded-3 p-3">
            <h1>Industry-Specific Expertise</h1>
            <hr />
            <p>
              Our trainers have years of experience working in the aviation
              sector, covering key areas such as aviation safety, regulatory
              compliance, airline operations, leadership, and aviation
              management.{" "}
            </p>
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-3   traning_card">
          <div className="custom-roadmap-box-container rounded-3 p-3">
            <h1>On-Demand Flexibility</h1>
            <hr />
            <p>
              Book training sessions that fit into your busy schedule. Whether
              you need live sessions or want to access pre-recorded workshops,
              our platform offers flexibility and convenience without any
              long-term commitments.{" "}
            </p>
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-3  traning_card">
          <div className="custom-roadmap-box-container rounded-3 p-3">
            <h1>Practical and Actionable Learning</h1>
            <hr />
            <p>
              {" "}
              Each session is designed to help you address real world aviation
              challenges, providing practical strategies and insights that can
              be applied directly to your work, whether in-flight operations,
              customer service, or management.
            </p>
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-3   traning_card">
          <div className="custom-roadmap-box-container rounded-3 p-3">
            <h1>Tailored for Aviation Professionals</h1>
            <hr />
            <p>
              {" "}
              Whether you're a pilot, airline manager, safety 
officer, or involved in aviation operations, our training programs are tailored to meet 
the specific needs of aviation professionals across different roles. 
            </p>
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-3   traning_card">
          <div className="custom-roadmap-box-container rounded-3 p-3">
            <h1>Post-Training Support</h1>
            <hr />
            <p>
              {" "}
              After completing a session, you can reach out for follow-up 
discussions or consultation to help implement the skills learned and address any 
industry-specific questions.
            </p>
          </div>
        </div>
      </div>


<div style={{ textAlign: 'center', padding: '2rem 1rem' }}>
  {/* Info Box */}
  <div style={{
    background: 'linear-gradient(135deg, #026D71, #00B0B6)',
    border: '2px solid #00F0F5',
    color: '#ffffff',
    borderRadius: '1rem',
    padding: '1.5rem',
    marginBottom: '1.5rem',
    boxShadow: '0 8px 20px rgba(0,0,0,0.15)'
  }}>
    <h2 style={{ fontSize: '1.75rem', marginBottom: '0.75rem', fontWeight: 700 }}>
      Elevate Your Aviation Career
    </h2>
    <p style={{ fontSize: '1rem', lineHeight: '1.6', marginBottom: '0.5rem' }}>
      Ready to take your aviation career to the next level? Our expert-led sessions will equip you with the skills you need to excel in the aviation industry.
    </p>
    <p style={{ fontSize: '1rem', lineHeight: '1.6', margin: 0 }}>
      Flexible schedules, practical insights, and post-training support included!
    </p>
  </div>

  {/* Button */}
  <div>
    <a href="/booking" style={{
      display: 'inline-block',
      background: 'linear-gradient(90deg, #026D71, #00B0B6)',
      color: '#fff',
      borderRadius: '50px',
      padding: '0.75rem 2.5rem',
      fontSize: '1.1rem',
      fontWeight: 700,
      textDecoration: 'none',
      transition: 'all 0.3s ease'
    }}
    onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
    onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
    >
      Book Your Session Today
    </a>
  </div>
</div>

      </div>


   
      
    </>
  );
}
